import { getTimeZone } from '../Utils/Utilities';
import apiService from './APIService';

// Check if user exists
export const checkIfExists = async (mobile, cc) => {
  try {
    const data = [{ mobile, cc }];
    const result = await apiService.accessGetData(1, 'checkIfExists', data);

    if (result?.Table) {
      return result;
    }
    throw new Error('Invalid response from server');
  } catch (error) {
    console.error('Error checking if exists:', error);
    throw error;
  }
};

// Send OTP for signup or reset PIN
export const sendOTP = async (mobile, cc, fromResend = false, isReset = false) => {
  try {
    const actionType = isReset ? 'resetPIN' : 'sendOTP';
    const data = [{ mobile, cc }];
    const result = await apiService.accessGetData(1, actionType, data);

    if (result?.error) {
      throw new Error(result.message || 'Failed to send OTP');
    }

    return {
      success: true,
      message: fromResend ? 'OTP is sent to your mobile number via WhatsApp.' : 'OTP sent successfully',
      data: result
    };
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error;
  }
};

// Signup new user
export const signup = async (userData) => {
  try {
    const data = [{
      agencyName: userData.companyName,
      name: userData.name,
      mobile: userData.mobile,
      cc: userData.countryCode,
      countryID: userData.countryID,
      email: userData.email,
      isWeb: true,
      otp: userData.otp,
      connID: userData.connID || 0,
      threadID: userData.threadID || 0,
      fcmToken: '',
      source: userData.src || '',
      signUpSrc: userData.signUpSrc,
      timeZone: getTimeZone()
    }];

    const result = await apiService.accessGetData(1, 'signUp', data);

    // Check for error code
    if (result.Table && result.Table[0].FnErrCode !== '-1') {
      throw new Error(result.Table[0].ErrMsg || 'Signup failed');
    }

    // Return jarvisData (Table1)
    if (result.Table1 && result.Table1.length > 0) {
      return result.Table1[0];
    }
    throw new Error('Invalid response from server');
  } catch (error) {
    console.error('Error signing up:', error);
    throw error;
  }
};
// Login user
export const login = async (mobile, cc, password, agencyID = 0, termsAccepted = false) => {
  try {
    const data = [{
      mobile,
      cc,
      password,
      isWeb: true,
      agencyID,
      fcmToken: '',
      TermsAccepted: termsAccepted
    }];

    const result = await apiService.accessGetData(1, 'login', data);

    // Check for error code
    if (result.Table && result.Table[0].FnErrCode !== '-1') {
      throw new Error(result.Table[0].ErrMsg || 'Login failed');
    }

    // Return jarvisData (Table1)
    if (result.Table1 && result.Table1.length > 0) {
      return result.Table1[0];
    }

  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};

// Switch Agency
export const switchAgency = async (mobile, cc, targetAgencyID) => {
  try {
    const data = [{
      mobile,
      cc,
      agencyID: targetAgencyID,
      isWeb: true,
      password: '',
      fcmToken: ''
    }];

    const result = await apiService.accessGetData(1, 'switchAgency', data);

    // Check for error code
    if (result.Table && result.Table[0].FnErrCode !== '-1') {
      throw new Error(result.Table[0].ErrMsg || 'Switch agency failed');
    }

    // Return jarvisData (Table1)
    if (result.Table1 && result.Table1.length > 0) {
      return result.Table1[0];
    }
    throw new Error('Invalid response from server');
  } catch (error) {
    console.error('Error switching agency:', error);
    throw error;
  }
};

// Respond to agency invitation (Accept / Reject)
export const respondInvitation = async (mobile, cc, agencyID, action, password = '') => {
  try {
    const data = [{
      mobile,
      cc,
      agencyID,
      action,
      password
    }];

    const result = await apiService.accessGetData(1, 'respondInvitation', data);

    // Check for error code
    if (result?.Table && result.Table[0]?.FnErrCode !== '-1') {
      throw new Error(result.Table[0].ErrMsg || `Failed to ${action.toLowerCase()} invitation`);
    }

    return result;
  } catch (error) {
    console.error('Error responding to invitation:', error);
    throw error;
  }
};